import { render, staticRenderFns } from "./TextStyleEditor.vue?vue&type=template&id=2c509fb8&scoped=true&"
import script from "./TextStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./TextStyleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextStyleEditor.vue?vue&type=style&index=0&id=2c509fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c509fb8",
  null
  
)

export default component.exports